;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export interface Currency {
  id: number;
  name: string;
  code: string;
  symbol: string;
  flag_code: string;
  billing_currency: boolean;
}

export interface CurrencyOption {
  id: string | number;
  name: string;
  value: string;
  image?: {
    path: string;
    alt: string;
  };
}
